/**
 * @name libraries
 * @description
 * Load url Assets from JS
 * @param url {string} URL
 */
export default class Libraries {

    constructor() {}

    load(url, callback) {

        // Instance
        let lib;

        // Get extension of url
        let urlExt = url.split('?')[0].split('.').slice(-1)[0];

        // Inject javascript assets
        if(urlExt === 'js'){
            lib = document.createElement("script");
            lib.type = "text/javascript";
            lib.src = url;
        }else if(urlExt === 'css'){ // Inject css file
            lib  = document.createElement('link');
            lib.id   = url.substring(url.lastIndexOf('/')+1).split('.')[0];
            lib.rel  = 'stylesheet';
            lib.type = 'text/css';
            lib.media = 'all';
            lib.href = url;
        }

        // Internet Explorer Browser
        if(lib){
            if (lib.readyState){
                lib.onreadystatechange = function(){
                    if (lib.readyState === "loaded" || lib.readyState === "complete"){
                        lib.onreadystatechange = null;
                        // Do Callback();
                    }
                };
            } else {
                // Normal Browser
                lib.onload = function(){
                    // Do Callback();
                };
            }

            document.getElementsByTagName("head")[0].appendChild(lib);
        }
    }
}